/* ==========================================================================
   Rynoka: toyland-faqs.js — Help Centre search + topic filter (page.faqs)

   Progressive enhancement only. The accordion itself is native <details>, so
   with JS disabled every answer is still readable and keyboard-operable; the
   section hides the search box and topic pills via <noscript> in that case.

   Section: sections/page-faqs.liquid · Styles: assets/toyland-faqs.css
   ========================================================================== */
(function () {
  'use strict';

  var DEBOUNCE_MS = 120;

  function normalise(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function init(root) {
    if (!root || root.dataset.tlFaqsReady === '1') return;

    var list = root.querySelector('[data-tl-faq-list]');
    if (!list) return;

    root.dataset.tlFaqsReady = '1';

    var input = root.querySelector('[data-tl-faq-input]');
    var clearBtn = root.querySelector('[data-tl-faq-clear]');
    var emptyEl = root.querySelector('[data-tl-faq-empty]');
    var countEl = root.querySelector('[data-tl-faq-count]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-tl-faq-pill]'));

    /* Read the searchable text straight off the DOM — <details> exposes its
       answer through textContent even while closed, so there is no need to
       duplicate every answer into a data- attribute. Cached once at init. */
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-tl-faq-item]')).map(function (el) {
      return {
        el: el,
        category: el.getAttribute('data-tl-faq-cat') || '',
        text: normalise(el.textContent)
      };
    });

    if (!items.length) return;

    var state = { query: '', category: '' };
    var timer = null;

    function matches(item) {
      if (state.category && item.category !== state.category) return false;
      if (state.query && item.text.indexOf(state.query) === -1) return false;
      return true;
    }

    function apply() {
      var shown = 0;

      items.forEach(function (item) {
        if (matches(item)) {
          item.el.removeAttribute('hidden');
          shown += 1;
        } else {
          /* Collapse on the way out so a filtered-back-in answer does not
             reappear already expanded halfway down the list. */
          item.el.removeAttribute('open');
          item.el.setAttribute('hidden', '');
        }
      });

      if (emptyEl) {
        if (shown === 0) emptyEl.removeAttribute('hidden');
        else emptyEl.setAttribute('hidden', '');
      }

      if (countEl) {
        countEl.textContent = shown === 0
          ? 'No questions match your search.'
          : 'Showing ' + shown + ' of ' + items.length + ' questions.';
      }

      if (clearBtn) {
        if (state.query) clearBtn.removeAttribute('hidden');
        else clearBtn.setAttribute('hidden', '');
      }
    }

    function setCategory(value, pill) {
      state.category = value;
      pills.forEach(function (btn) {
        var active = btn === pill;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      apply();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        setCategory(pill.getAttribute('data-tl-faq-pill') || '', pill);
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          state.query = normalise(input.value);
          apply();
        }, DEBOUNCE_MS);
      });

      /* The input sits inside no <form>, so Enter/Escape need handling here. */
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (timer) clearTimeout(timer);
          state.query = normalise(input.value);
          apply();
        } else if (event.key === 'Escape' && input.value) {
          event.preventDefault();
          input.value = '';
          state.query = '';
          apply();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (timer) clearTimeout(timer);
        if (input) {
          input.value = '';
          input.focus();
        }
        state.query = '';
        apply();
      });
    }

    apply();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-tl-faqs]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: a section re-render replaces the markup, so re-bind. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
